const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const log = require('log').create('button') // eslint-disable-line

class Button extends React.Component {

    mapPropsToAttrs() {
        // maps Button props to DOM node attributes
        // some props map directly to attributes, e.g. href
        // other props map to classnames, e.g. size, color

        const {
            type,
            href,
            active,
            size,
            rank,
            luminance,
            style,
            loading,
            onClick,
        } = this.props

        // set disabled to true if loading is true
        const disabled = this.props.disabled || loading

        // construct our classname
        const className = classNames([
            'button',
            size,
            rank,
            luminance,
            this.props.className,
        ], {
            active,
            loading,
            disabled,
        })

        // build attributes hash
        const attrs = {
            className,
            style,
            disabled,
            onClick,
        }

        if (href) {
            // only assign attrs.href if it exists
            attrs.href = href
        } else {
            // only assign attrs.type if no href
            attrs.type = type
        }

        return attrs
    }

    renderLink() {
        const attrs = this.mapPropsToAttrs()
        const { children } = this.props
        return (
            <a {...attrs}>
                {children}
            </a>
        )
    }

    renderButton() {
        const attrs = this.mapPropsToAttrs()
        const { children, loading_text } = this.props
        return (
            <button {...attrs}>
                <span className="default-text">{children}</span>
                <span className="loading-text">{loading_text || children}</span>
            </button>
        )
    }

    render() {
        if (this.props.href) {
            return this.renderLink()
        }
        return this.renderButton()
    }

}
Button.propTypes = {
    type: PropTypes.oneOf([
        'button',
        'submit',
        'reset',
    ]),
    href: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    size: PropTypes.oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
    ]),
    rank: PropTypes.oneOf([
        'danger',
        'primary',
        'secondary',
        'tertiary',
        'quaternary',
    ]),
    luminance: PropTypes.oneOf([
        'light',
        'dark',
    ]),
    className: PropTypes.string,
    style: PropTypes.object,
    loading: PropTypes.bool,
    loading_text: PropTypes.string,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.string.isRequired,
}
Button.defaultProps = {
    type: 'button',
    href: false,
    disabled: false,
    loading: false,
    active: false,
}

module.exports = Button
